/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".callout_e8e64567 .ms-Suggestions-itemButton{padding:0px;border:none}.callout_e8e64567 .ms-Suggestions{min-width:300px}\n"}]);
export const callout = "callout_e8e64567";


// WEBPACK FOOTER //
// ../src/components/FloatingPicker/BaseFloatingPicker.scss.ts